import { render, staticRenderFns } from "./SessionDetailsModal.vue?vue&type=template&id=09dec817&"
import script from "./SessionDetailsModal.vue?vue&type=script&lang=js&"
export * from "./SessionDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports